define('models/calendar/nutrition/recipe',[
    'underscore', 'backbone', 'utils',
    // services
    'services/api',
    // models
    'models/calendar/nutrition/food',
], function(
    _, Backbone, U, API,
    // models
    MFood
) {

    var MFoodFavorite = MFood.extend({
        blacklist: ['type'],
        urlRoot: function() {
            var url = "nutrition/favorites/";
            if (this.isNew()) url += "recipe/";

            return API.url(url);
        },

        initialize: function(attrs, options) {
            this.set({ type: "recipe" });

            MFoodFavorite.__super__.initialize.apply(this, arguments);
        },

        setEntries: function(entries) {
            return this.set({
                entries: _.map(entries, function(entry) {
                    return _.extend(entry, {
                        servingId: entry.foodServing.split(':')[1],
                        foodId: entry.foodServing.split(':')[0],
                    });
                })
            });
        },

        getEntries: function() {
            return this.get('entries');
        },

        setServing: function(serving) {
            this.set({ servingName: serving.name, servingQty: serving.qty });
        },

    });

    return MFoodFavorite;
});

